<template>
  <div style="width: 100%;" v-show="cacheAttachmentList.length > 0">
    <span style="font-size: 14px">上传附件</span>
    <div class="attachmentContainer">
      <el-tag
        style="margin-right: 5px"
        v-for="(item, index) of cacheAttachmentList"
        @close="fileRemove(index)"
        :key="index"
        closable
        type="primary"
        size="mini"
      >
        {{ item.name }}
      </el-tag>
    </div>
    <!-- 选择文件夹 -->
    <input type="file" ref="uploadExcel" v-show="false" id="open" multiple="multiple" @change="uploadFile" />
    <vxe-modal v-model="showProress" title="进度" :showHeader="false" height="50" size="mini">
      <el-progress
        :text-inside="true"
        :stroke-width="26"
        :percentage="percentage"
        :format="processformat"
      ></el-progress>
    </vxe-modal>
  </div>
</template>
<script>
import { BASEURL } from '@/axios/baseUrlConfig.js'
export default {
  props: {
    cacheFileID: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // 缓存文件列表
      cacheAttachmentList: [],
      // 是否显示进度
      showProress: false,
      // 当前显示进度字符串
      processStr: '',
      // 进度百分比
      percentage: 0,
      // 总上传数量
      fileCount: 0,
      // 上传完成信息
      completeList: [],
      // 上传信息
      arrayUpload: []
      // 新增上传文件使用的id
      // cacheFileID: 0
    }
  },
  methods: {
    // 上传文件回调函数
    async sureUpload() {
      for (let item of this.cacheAttachmentList) {
        await this.uploadSingle(item)
      }
    },
    // 上传附件
    uploadAttachment() {
      this.$refs.uploadExcel.click()
    },
    // 当文件变化时
    async uploadFile(event) {
      let that = this
      // if (this.attachRowIdList.length > 0) {
      if (event.target.files.length === 0) {
        return
      }
      // 限制只能上传一个
      // that.fileCount = 1
      that.completeList = []
      that.arrayUpload = []
      that.percentage = 0
      that.processStr = `${that.percentage}%`
      for (let fileObj of event.target.files) {
        // that.uploadSingle(fileObj)
        this.cacheAttachmentList.push(fileObj)
      }
      that.fileCount = this.cacheAttachmentList.length
      // that.uploadSingle(event.target.files[0])
      // }
      event.target.value = ''
    },
    // 上传一个文件
    uploadSingle(fileObj) {
      let upload = BASEURL.upload
      if (!upload) {
        upload = window.location.origin
      }
      const that = this
      const guID = that.guid()
      let formData = new FormData()
      formData.append('file', fileObj)
      formData.append('vuePathName', '')
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'accept-language': 'zh-CN',
          'loading': false
        },
        timeout: 0
      }
      that.$http
        .post(`${upload}/upload?X-Progress-ID=${guID}`, formData, config)
        .then(async ({ data: res }) => {
          if (res.isSuccess) {
            that.completeList.push(res.data)
            if (that.completeList.length === that.fileCount) {
              await that.writeToDB()
            }
          } else {
            that.$message.error(res.errorMessage)
          }
        })
        .catch(err => {
          that.$message.error(err)
        })
      let timer = setInterval(async () => {
        let { data: res } = await that.$http.get(`${upload}/progress?X-Progress-ID=${guID}`, {
          headers: { loading: false }
        })
        res = res.replace('(', '')
        res = res.replace(')', '')
        res = res.replace(';', '')
        res = JSON.parse(res)
        if (res.state === 'uploading') {
          let pre = 100
          if (res.size > 0) {
            pre = res.received / res.size
            pre = (pre * 100).toFixed(2)
            if (res.received < res.size && pre === 100) {
              pre = 99.99
            }
          }
          let option = that.arrayUpload.filter(item => {
            return item.guID === guID
          })
          if (option.length > 0) {
            option[0].pre = pre
          }
          that.pre()
        } else {
          let option = that.arrayUpload.filter(item => {
            return item.guID === guID
          })
          if (option.length > 0) {
            option[0].pre = 100
          }
          that.pre()
          clearInterval(timer)
        }
      }, 1000)
      that.arrayUpload.push({ guID: guID, timer: timer, pre: 0 })
      setTimeout(() => {
        if (that.percentage < 100) {
          that.showProress = true
        }
      }, 500)
    },
    // 计算总进度
    pre() {
      let that = this
      let sumPre = this.$utils.sum(that.arrayUpload, 'pre')
      that.percentage = sumPre / that.fileCount
      that.processStr = `${that.percentage}%`
    },
    // 写入应用服务器
    async writeToDB() {
      let that = this
      const fileList = that.completeList.map(item => {
        const temp = {
          objectID: that.cacheFileID,
          objectType: 'DPBugs',
          display: item.aDisplay,
          filePath: item.aPath,
          type: item.aType,
          addedBy: this.$store.state.userInfo.userName,
          addedTime: this.ykDateFormat('yyyy-MM-dd', new Date()),
          byteSize: item.aLength
        }
        return temp
      })
      const { data: res } = await that.$http.post(`/Common/DPBugs/file`, fileList)
      if (res.isSuccess) {
        this.$emit('uploadFileSuccess')
      } else {
        that.$message.error(res.errorMessage)
      }
      that.percentage = 100
      that.completeList = []
      that.arrayUpload = []
      that.showProress = false
    },
    // 获取guid
    guid() {
      var guid = ''
      for (var i = 1; i <= 32; i++) {
        var n = Math.floor(Math.random() * 16.0).toString(16)
        guid += n
        if (i === 8 || i === 12 || i === 16 || i === 20) guid += '-'
      }
      return guid
    },
    // 进度格式化
    processformat() {
      return this.processStr
    },
    // 删除文件
    fileRemove(index) {
      const that = this
      this.$confirm('确认删除该文件吗？', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.cacheAttachmentList.splice(index, 1)
        that.fileCount = that.cacheAttachmentList.length
      })
    }
  }
}
</script>
<style lang="less" scoped>
.attachmentContainer {
  word-break: break-word;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none !important;
  }
}
</style>
